<template>
    <div 
        class="o-p-service-info"
        :style="componentStyles"
    >
        <div class="o-p-service-info__header">
            {{$t('componentParams.service', 'Services')}}
        </div>
        <div class="o-p-service-info__services">
            <div 
                class="o-p-service-info__service-item"
                v-for="service in getServiceCategories"
                :key="service.id"
            >
                <div
                    class="o-p-service-info__service-item-name"
                >
                    {{t(service, 'name')}}
                </div>
                <img class="o-p-service-info__service-item-icon" :src="service.files.icon" alt="service icon">
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
    
export default {
    name: 'OPServiceInfo',
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getServiceCategories'
        ]),
        componentStyles() {
            return this.getMapConfigProp('components.OPServiceInfo.styles') || {};
        },
        componentParams() {
            return this.getMapConfigProp('components.OPServiceInfo.params') || {};
        },
    }
}
</script>

<style lang="scss">
@import "theme";
</style>